module.exports = __webpack_public_path__ + "img/cart.7bc09e6a.svg";